export enum ThemeType {
  Dark = 'dark',
  Light = 'light',
}